var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptLogo02Lightmode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 51",
    style: {
      enableBackground: "new 0 0 220 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    transform: "translate(6284.873 -875.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    fill: "#4C5374",
    d: "M-6209.12,886.27c6.98,0,10.46,4.02,10.46,8.96c0.08,3.89-2.54,7.31-6.32,8.23l6.57,11.27h-7.83 l-5.92-10.74h-1.66v10.74h-6.93v-28.46L-6209.12,886.27z M-6209.53,892.03h-4.3v7.06h4.3c2.59,0,3.81-1.34,3.81-3.57 C-6205.71,893.41-6206.93,892.03-6209.53,892.03L-6209.53,892.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    fill: "#4C5374",
    d: "M-6185.88,915.06c-6.65,0-11.43-4.46-11.43-11.64s4.7-11.64,11.43-11.64 c6.61,0,11.27,4.38,11.27,11.27c0,0.68-0.04,1.35-0.12,2.03h-15.69c0.24,2.96,2.07,4.34,4.3,4.34c1.54,0.1,2.98-0.78,3.61-2.19 h7.38C-6176.23,911.65-6180.24,915.06-6185.88,915.06z M-6190.38,901.24h8.67c0-2.47-1.95-3.89-4.26-3.89 C-6188.23,897.26-6190.17,898.97-6190.38,901.24L-6190.38,901.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    fill: "#4C5374",
    d: "M-6160.97,891.79c5.68,0,9.69,3.12,10.86,8.51h-7.38c-0.45-1.6-1.95-2.67-3.61-2.59 c-2.47,0-4.18,1.95-4.18,5.72s1.7,5.72,4.18,5.72c1.67,0.1,3.17-0.98,3.61-2.59h7.38c-1.18,5.23-5.19,8.52-10.86,8.52 c-6.65,0-11.36-4.46-11.36-11.64C-6172.32,896.29-6167.62,891.79-6160.97,891.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    fill: "#4C5374",
    d: "M-6140.28,914.73h-6.93v-22.62h6.93v3.77c1.52-2.47,4.2-3.98,7.09-4.01v7.34h-1.91 c-3.28,0-5.19,1.13-5.19,5.03L-6140.28,914.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    fill: "#4C5374",
    d: "M-6113.43,892.11h7.5l-14.19,33.36h-7.46l5.19-11.52l-9.2-21.85h7.75l5.23,14.15 L-6113.43,892.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    fill: "#4C5374",
    d: "M-6090.31,891.79c5.56,0,9.97,4.46,9.97,11.6s-4.42,11.68-9.97,11.68 c-2.77,0.1-5.39-1.21-6.97-3.49v13.94h-6.93v-33.41h6.93v3.21C-6095.73,893-6093.09,891.66-6090.31,891.79z M-6092.38,897.83 c-2.6,0-4.95,1.99-4.95,5.6s2.35,5.6,4.95,5.6c2.64,0,4.99-2.03,4.99-5.64C-6087.39,899.78-6089.74,897.83-6092.38,897.83 L-6092.38,897.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    fill: "#4C5374",
    d: "M-6076.39,897.87h-2.76v-5.76h2.76v-5.51h6.93v5.51h4.54v5.76h-4.54v9.08 c0,1.34,0.57,1.9,2.11,1.9h2.47v5.88h-3.53c-4.7,0-7.99-1.99-7.99-7.87V897.87z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    fill: "#34DAE2",
    d: "M26.45,22.59l4.63-3.87l2.49,4.53l-5.47,1.92l5.48,1.87l-2.67,4.72l-4.45-3.92l1.11,5.79h-5.21 l1.07-5.79l-4.41,3.96l-2.76-4.81l5.47-1.91l-5.43-1.78l2.54-4.58l4.63,3.87l-1.16-5.87h5.3L26.45,22.59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    fill: "#34DAE2",
    d: "M0,0.26v49.82h49.82V0.26H0z M42.89,43.15H6.93V7.2h35.96V43.15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptLogo02Lightmode);
export default __webpack_public_path__ + "static/media/recrypt_logo_02_lightmode.e96e51fb.svg";
export { ForwardRef as ReactComponent };